import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';
import { InterfaceLanguage } from '../../../shared/constants/languages';

@Component({
  selector: 'app-simple-header',
  imports: [MatButtonModule, RouterLink, TranslocoPipe],
  templateUrl: './simple-header.component.html',
  styleUrl: './simple-header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleHeaderComponent {
  lang = input.required<InterfaceLanguage>();
  register = input<boolean>(true);
}
